// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const MsEdgeIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <g clipPath="url(#ms-edge_svga)">
      <path
        fill="url(#ms-edge_svgb)"
        d="M20.86 17.37q-.45.23-.91.4-1.5.56-3.09.55c-4.06 0-7.6-2.79-7.6-6.38a2.7 2.7 0 0 1 1.4-2.35c-3.67.16-4.62 4-4.62 6.23 0 6.36 5.86 7 7.12 7 .68 0 1.7-.2 2.32-.4l.11-.03a11 11 0 0 0 5.73-4.54.34.34 0 0 0-.46-.48"
      />
      <path
        fill="url(#ms-edge_svgc)"
        d="M20.86 17.37q-.45.23-.91.4-1.5.56-3.09.55c-4.06 0-7.6-2.79-7.6-6.38a2.7 2.7 0 0 1 1.4-2.35c-3.67.16-4.62 4-4.62 6.23 0 6.36 5.86 7 7.12 7 .68 0 1.7-.2 2.32-.4l.11-.03a11 11 0 0 0 5.73-4.54.34.34 0 0 0-.46-.48"
        opacity={0.35}
      />
      <path
        fill="url(#ms-edge_svgd)"
        d="M10.08 21.74a6.94 6.94 0 0 1 .58-12.14 2.78 2.78 0 0 1 4.1 2.38c0-.02 2.1-6.85-6.88-6.85-3.77 0-6.87 3.58-6.87 6.72q-.02 2.52 1.04 4.82a11 11 0 0 0 13.44 5.75 6.5 6.5 0 0 1-5.4-.68"
      />
      <path
        fill="url(#ms-edge_svge)"
        d="M10.08 21.74a6.94 6.94 0 0 1 .58-12.14 2.78 2.78 0 0 1 4.1 2.38c0-.02 2.1-6.85-6.88-6.85-3.77 0-6.87 3.58-6.87 6.72q-.02 2.52 1.04 4.82a11 11 0 0 0 13.44 5.75 6.5 6.5 0 0 1-5.4-.68"
        opacity={0.41}
      />
      <path
        fill="url(#ms-edge_svgf)"
        d="M14.1 13.79c-.08.08-.3.21-.3.48q0 .35.42.63c1.23.86 3.55.74 3.56.74A5.28 5.28 0 0 0 23 10.38c.03-1.93-.69-3.21-.97-3.78C20.2 3.05 16.27 1 12 1A11 11 0 0 0 1 11.85c.04-3.14 3.16-5.68 6.88-5.68.3 0 2.01.03 3.6.86a6.2 6.2 0 0 1 2.66 2.52c.52.91.62 2.07.62 2.54 0 .46-.23 1.14-.67 1.7"
      />
      <path
        fill="url(#ms-edge_svgg)"
        d="M14.1 13.79c-.08.08-.3.21-.3.48q0 .35.42.63c1.23.86 3.55.74 3.56.74A5.28 5.28 0 0 0 23 10.38c.03-1.93-.69-3.21-.97-3.78C20.2 3.05 16.27 1 12 1A11 11 0 0 0 1 11.85c.04-3.14 3.16-5.68 6.88-5.68.3 0 2.01.03 3.6.86a6.2 6.2 0 0 1 2.66 2.52c.52.91.62 2.07.62 2.54 0 .46-.23 1.14-.67 1.7"
      />
    </g>
    <defs>
      <radialGradient
        id="ms-edge_svgc"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(8.19844 0 0 7.78852 14.51 16.33)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.7} stopOpacity={0} />
        <stop offset={0.9} stopOpacity={0.5} />
        <stop offset={1} />
      </radialGradient>
      <radialGradient
        id="ms-edge_svge"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(1.84592 -12.18315 9.8428 1.49132 7.06 18.1)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.8} stopOpacity={0} />
        <stop offset={0.9} stopOpacity={0.5} />
        <stop offset={1} />
      </radialGradient>
      <radialGradient
        id="ms-edge_svgf"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-.69575 17.3938 -37.04508 -1.4818 3.22 5.07)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#35C1F1" />
        <stop offset={0.1} stopColor="#34C1ED" />
        <stop offset={0.2} stopColor="#2FC2DF" />
        <stop offset={0.3} stopColor="#2BC3D2" />
        <stop offset={0.7} stopColor="#36C752" />
      </radialGradient>
      <radialGradient
        id="ms-edge_svgg"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(73.74 5.72 18.24)scale(8.36172 6.79975)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#66EB6E" />
        <stop offset={1} stopColor="#66EB6E" stopOpacity={0} />
      </radialGradient>
      <linearGradient
        id="ms-edge_svgb"
        x1={6.04}
        x2={21.38}
        y1={16.21}
        y2={16.21}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0C59A4" />
        <stop offset={1} stopColor="#114A8B" />
      </linearGradient>
      <linearGradient
        id="ms-edge_svgd"
        x1={14.12}
        x2={4.56}
        y1={9.56}
        y2={19.98}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B9DE2" />
        <stop offset={0.2} stopColor="#1595DF" />
        <stop offset={0.7} stopColor="#0680D7" />
        <stop offset={1} stopColor="#0078D4" />
      </linearGradient>
      <clipPath id="ms-edge_svga">
        <path fill="#fff" d="M1 1h22v22H1z" />
      </clipPath>
    </defs>
  </svg>,
  "MsEdge",
);
export default MsEdgeIcon;
